<template>
    <BreadCrumb PageTitle="Liste des contacts" />
    <ListeContact/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeContact from "../../components/ContactSMS/ListeContact.vue";

    export default defineComponent({
      name: "ListeContactsPage",
      components: {
        BreadCrumb,
        ListeContact,
      },
    });
  </script>